import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AdminReviews from "./pages/AdminReviews";
import AdminInquiries from "./pages/AdminInquiries";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin/reviews" element={<AdminReviews />} />
        <Route path="/admin/inquiries" element={<AdminInquiries />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
